"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePresentationContext = exports.PresentationProvider = exports.PresentationContext = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
exports.PresentationContext = (0, react_1.createContext)({});
function PresentationProvider(props) {
    const { children, ...presentationProps } = props;
    // Check to see if we are nested within another PresentationContext. If so, make sure values already above us are passed through if not overwritten (except baseContext)
    const existingContext = usePresentationContext();
    const context = (0, react_1.useMemo)(() => {
        const fieldProps = { ...existingContext.fieldProps, ...presentationProps.fieldProps };
        return { ...existingContext, ...presentationProps, fieldProps };
    }, [presentationProps, existingContext]);
    return (0, jsx_runtime_1.jsx)(exports.PresentationContext.Provider, { value: context, children: children });
}
exports.PresentationProvider = PresentationProvider;
function usePresentationContext() {
    return (0, react_1.useContext)(exports.PresentationContext);
}
exports.usePresentationContext = usePresentationContext;
